module.exports = __webpack_public_path__ + "img/logo-um-fgpa-ang.9adb3e6a.png";